import {agencesConstants} from "./agences.constants";
import {agencesService} from "./agences.service";
import {toastHelper} from "../../utils/toast-helper";
import Constants from "../../utils/constants";
import history from "../../utils/history";

export const agencesActions = {
    fetchAgences,
    fetchAgence,
    createAgence,
    updateAgence,
    deleteAgence,
};

function fetchAgences() {
    return dispatch => {
        dispatch(request());

        agencesService.fetchAgences()
            .then(
                agences => {
                    dispatch(success(agences));
                },
                error => {
                    dispatch(failure(error.toString()));
                }
            );
    };

    function request() {
        return {type: agencesConstants.AGENCES_FETCH_REQUEST}
    }

    function success(agences) {
        return {type: agencesConstants.AGENCES_FETCH_SUCCESS, agences}
    }

    function failure(error) {
        toastHelper.handleError(error, "Oops, une erreur est survenue.")
        return {type: agencesConstants.AGENCES_FETCH_FAILURE, error}
    }
}

function fetchAgence(id) {
    return dispatch => {
        dispatch(request());

        agencesService.fetchAgence(id)
            .then(
                agence => {
                    dispatch(success(agence));
                },
                error => {
                    if (!error || error === "") error = "Une erreur est survenue"
                    dispatch(failure(error.toString()));
                }
            );
    };

    function request() {
        return {type: agencesConstants.AGENCES_FETCH_ONE_REQUEST}
    }

    function success(agence) {
        return {type: agencesConstants.AGENCES_FETCH_ONE_SUCCESS, agence}
    }

    function failure(error) {
        toastHelper.handleError(error, "Oops, une erreur est survenue.")
        return {type: agencesConstants.AGENCES_FETCH_ONE_FAILURE, error}
    }
}

function createAgence(values, callback = null) {
    return dispatch => {
        dispatch(request());

        agencesService.createAgence(values)
            .then(
                (agence) => {
                    dispatch(success(agence));
                    if (callback) {
                        callback(agence);
                    } else {
                        history.replace(Constants.APP_ROUTE_ADMIN_AGENCES);
                    }
                },
                error => {
                    dispatch(failure(error.toString()));
                }
            );
    };

    function request() {
        return {type: agencesConstants.AGENCES_CREATE_REQUEST}
    }

    function success(agence) {
        toastHelper.displaySuccess("L'agence a bien été créée.")
        return {type: agencesConstants.AGENCES_CREATE_SUCCESS, agence}
    }

    function failure(error) {
        toastHelper.handleError(error, "Oops, une erreur est survenue.")
        return {type: agencesConstants.AGENCES_CREATE_FAILURE, error}
    }
}

function updateAgence(id, values, callback = null) {
    return dispatch => {
        dispatch(request());

        agencesService.updateAgence(id, values)
            .then(
                (agence) => {
                    dispatch(success(agence));
                    if (callback) {
                        callback(agence);
                    } else {
                        history.replace(Constants.APP_ROUTE_ADMIN_AGENCES);
                    }
                },
                error => {
                    dispatch(failure(error.toString()));
                }
            );
    };

    function request() {
        return {type: agencesConstants.AGENCES_UPDATE_REQUEST}
    }

    function success(agence) {
        toastHelper.displaySuccess("L'agence a bien été modifiée.")
        return {type: agencesConstants.AGENCES_UPDATE_SUCCESS, agence}
    }

    function failure(error) {
        toastHelper.handleError(error, "Oops, une erreur est survenue.")
        return {type: agencesConstants.AGENCES_UPDATE_FAILURE, error}
    }
}

function deleteAgence(id) {
    return dispatch => {
        dispatch(request());

        agencesService.deleteAgence(id)
            .then(
                () => {
                    dispatch(success(id));
                    history.replace(Constants.APP_ROUTE_ADMIN_AGENCES);
                },
                error => {
                    dispatch(failure(error.toString()));
                }
            );
    };

    function request() {
        return {type: agencesConstants.AGENCES_DELETE_REQUEST}
    }

    function success(id) {
        toastHelper.displaySuccess("L'agence a bien été supprimée.")
        return {type: agencesConstants.AGENCES_DELETE_SUCCESS, id}
    }

    function failure(error) {
        toastHelper.handleError(error, "Oops, une erreur est survenue.")
        return {type: agencesConstants.AGENCES_DELETE_FAILURE, error}
    }
}
